const unitFormModel = {
  formId: 'unitForm',
  formField: {
    unitName: {
      name: 'unitName',
      label: 'Unit Name',
      required: true,
      requiredErrorMsg: 'Unit Name is required',
    },
    development: {
      name: 'Development',
      label: 'Development',
      required: true,
      requiredErrorMsg: 'Title is required',
  },
  developmentName: {
      name: 'DevelopmentName',
      label: 'DevelopmentName',
      required: true,
      requiredErrorMsg: 'Title is required',
  },
  project: {
      name: 'Project',
      label: 'Project',
      required: true,
      requiredErrorMsg: 'Title is required',
  },
  projectName: {
      name: 'project Name',
      label: 'project Name',
      required: true,
      requiredErrorMsg: 'Title is required',
  }
  },
  initialValues: {
    unitName: '',
    development: '',
        project: '',
        developmentName: '',
        projectName: '',
  },
};

export type UnitType = {
  unitName: string;
  development: string;
  project: string;
  developmentName: string;
  projectName: string;
};

export default unitFormModel;
